import { Gender, IDeliveryAddress, Title } from '@alberta/konexi-shared';
import { ignore } from 'src/app/common/tracking/tracker';
import { PostalCodeModelName } from 'src/app/shared/models/model-names';
import { GeneralEntityService } from 'src/app/shared/services/general-entity.service';

export class DeliveryAddressViewModel implements IDeliveryAddress {
  gender?: Gender;
  title?: Title;
  additionalAddress2: string;
  name: string;
  address: string;
  additionalAddress: string;
  postalCode: string;
  city: string;
  postalCodeId: string;

  @ignore()
  type: string;

  public async initializePostalCode(generalEntityService: GeneralEntityService, postalCodeId: string) {
    generalEntityService.type = PostalCodeModelName;
    const postalCodeItem = await generalEntityService.find(postalCodeId);
    if (postalCodeItem) {
      this.postalCode = postalCodeItem.postalCode;
      this.city = postalCodeItem.city;
    }
  }
}
